import { Component, Input, OnInit } from '@angular/core';
import { SearchFacet } from '../../../api/models/search-facet';
import { SearchEventPublisher } from '../../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../../shared/model/search-event-type-enum';
import { SearchFacetValue } from '../../../api/models/search-facet-value';
import { AnalyticsService } from '../../../shared/service/analytics/analytics.service';
import { FacetData, SearchResult } from 'src/app/api/models';
import { FacetDataHolderService } from '../../../shared/service/facet-data-holder.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-secondary-navigation-dropdown-filter',
  templateUrl: './secondary-navigation-dropdown-filter.component.html',
  styleUrls: ['./secondary-navigation-dropdown-filter.component.scss']
})
@UntilDestroy()
export class SecondaryNavigationDropdownFilterComponent implements OnInit {
  @Input()
  narrowByFacets: Array<SearchFacet> | undefined = [];

  @Input()
  searchResult?: SearchResult;

  isOpen: boolean = false;
  isFacetsOpen: Array<boolean> = [];
  searchValue: string = "";
  facetData?: FacetData;

  constructor(private searchEventPublisher: SearchEventPublisher,
              private analyticsService: AnalyticsService,
              private facetDataHolder: FacetDataHolderService) {

  }

  ngOnInit(): void {
    this.createHashMap();
    this.facetDataHolder.getFacetData()
      .pipe(untilDestroyed(this))
      .subscribe(fd => this.facetData = fd);
  }

  private createHashMap() {
    if (this.narrowByFacets?.length) {
      for (let i = 0; i < this.narrowByFacets?.length; i += 1) {
        this.isFacetsOpen.push(false);
      }
    }
  }

  toggleFilter() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  toggleFacet(index: number) {
    this.isFacetsOpen.forEach((element, arrayIndex) => {
      if (arrayIndex === index) {
        this.isFacetsOpen[arrayIndex] = !this.isFacetsOpen[arrayIndex];
      } else {
        this.isFacetsOpen[arrayIndex] = false;
      }
    });
  }

  filtering(facet: SearchFacetValue) {
    facet.selected = !facet.selected;
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.NARROW_BY_FACET, facet.params);
    this.analyticsService.trackNavigationChange(facet.params.sn, this.facetData?.facetCodeNameMap, this.facetData?.facetValueCodeNameMap, undefined);
    this.closeDropdown();
  }

  getSearchValues(subFacet: SearchFacetValue, facet: SearchFacet) {
    return subFacet.displayString.toUpperCase().indexOf(this.searchValue.toUpperCase()) > -1 && facet.fieldName === 'manufacturer_fn' || facet.fieldName !== 'manufacturer_fn';
  }

  clearSearchValue() {
    this.searchValue = "";
  }
}
